import React,  { useEffect, useState } from 'react';
import { withRouter, useHistory, useLocation } from 'react-router-dom';
import { FormattedMessageWithClass, Image, Link } from '../commonComponents';
import content from 'Content/content.json';
import FooterConfig, { isEmptySocial } from '../../configuration/Footer';
import { language, LANG_JP, LANG_VI, LANG_AZ } from 'Root/constants';
import { Youtube_icon, Facebook_icon, Ins_icon } from '../commonComponents/svg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight } from '@fortawesome/free-solid-svg-icons';
import './banner.scss';
import { ClickLayer } from '../../ga4';
import { Banner_arrow, Banner_icon, Virtual_mirror } from '../commonComponents/svg';
import { banner_1, banner_2, banner_down_arrow } from '../../assets/imgs';
import { FormattedMessage, useIntl } from 'react-intl';

const Banner = () => {
  const [pageName, setPage] = useState('');
  const { formatMessage } = useIntl();
  const location = useLocation();

  const heroConfig = {
    totalSlides: 2,
    slideDuration: 12, // seconds
    transition: 0.7, // seconds
    content: [
      {
        title: formatMessage({ id: 'banner_01_title', defaultMessage: 'Define<span>®</span><br /><em>Classic</em>' }),
        subheading: formatMessage({ id: 'banner_01_content', defaultMessage: 'Natural-toned hues that accentuate with bold charisma.' }),
      },
      {
        title: formatMessage({ id: 'banner_02_title', defaultMessage: 'Define<span>®</span><br /><em>Fresh</em>' }),
        subheading: formatMessage({ id: 'banner_02_content', defaultMessage: 'Nature-inspired colours designed to enhance and brighten.' }),
      },
    ],
  };

  const [slideIndex, setSlideIndex] = useState(0);

  const history = useHistory();

  const redirectTo = (url) => {

    history.push(url);
  }

  useEffect(() => {
    const heroInterval = heroConfig.slideDuration * 1000;
    const interval = setInterval(() => {
      setSlideIndex((prevIndex) => (prevIndex + 1) % heroConfig.totalSlides);
    }, heroInterval);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const heroSlideItems = [
      document.querySelector(".hero .content h1"),
      document.querySelector(".hero .content p"),
      document.querySelector(".hero .illustration img"),
    ];

    heroSlideItems.forEach((elem) => {
      elem.style.opacity = 0; // Initially set opacity to 0 for the fade effect
      function onTransitionEnd() {
        setTimeout(() => {
          heroSlideItems[0].innerHTML = heroConfig.content[slideIndex].title;
          heroSlideItems[1].innerHTML = heroConfig.content[slideIndex].subheading;
          heroSlideItems[2].src = [banner_1, banner_2][slideIndex];

          elem.style.opacity = 1; // Set opacity back to 1 after a short delay for the fade effect
        }, 700);
      }
      onTransitionEnd();
    });

  }, [slideIndex]);

  const handleDotClick = (index) => {
    setSlideIndex(index);
  };

  const renderDots = () => {
    return Array.from({ length: heroConfig.totalSlides }, (_, index) => (
      <div
        key={index}
        className={`dot ${index === slideIndex ? 'current-page' : ''}`}
        onClick={() => handleDotClick(index)}
      />
    ));
  };

  return (
    <section className="hero">
      <div className="illustration">
        <Banner_icon></Banner_icon>
        <img className="hero-image" alt="A model showcasing Define® contact lenses" />
      </div>
      <div className="content">
        <h1></h1>
        <p></p>
        <div className="button-stack">
          <a onClick={() => redirectTo('/vm')} className="discover-btn primary">
            <div className="mirror btn-icon">
              {/* TODO */}
              <Virtual_mirror></Virtual_mirror>
            </div>
            <FormattedMessage id="banner_button_01" defaultMessage='Virtual Mirror' />
            <div className="arrow btn-icon">
              <Banner_arrow></Banner_arrow>
            </div>
          </a>
          <a onClick={() => redirectTo('/discover')} className="discover-btn secondary">
            <FormattedMessage id="banner_button_02" defaultMessage='Discover Define®' />
            <div className="arrow btn-icon">
              <Banner_arrow></Banner_arrow>
            </div>
          </a>
        </div>
        <img src={ banner_down_arrow } className="long-arrow" />
      </div>
      <div className="pagination">
        {renderDots()}
      </div>
    </section>
  );
};

export default Banner;
